<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="flex flex-col gap-4">
        <span class="flex flex-col items-center">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="30" fill="#FFF2E0"/>
            <circle cx="19.0059" cy="20.999" r="14" fill="#FFF2E0"/>
            <circle cx="30.4961" cy="24.498" r="3.5" fill="white"/>
            <circle cx="44.9961" cy="35.001" r="4" fill="#FCE3B6"/>
            <path d="M27.7063 33.2722L27.9307 32.4346C28.1248 31.7102 28.4484 31.1215 28.9013 30.6686C29.3543 30.2157 30.0729 29.7976 31.0572 29.4143C32.0013 29.0607 32.6453 28.7399 32.9894 28.4519C33.341 28.166 33.5754 27.8042 33.6927 27.3665C33.8241 26.876 33.7431 26.4539 33.4496 26.1003C33.1561 25.7467 32.6849 25.4829 32.0359 25.309C30.904 25.0057 29.5145 25.0297 27.8675 25.381L27.2979 22.5715C29.2334 22.0791 31.1445 22.0856 33.0311 22.5911C34.5856 23.0077 35.7194 23.7118 36.4323 24.7036C37.1527 25.6973 37.3462 26.8168 37.0125 28.0619C36.7901 28.892 36.4094 29.5584 35.8703 30.061C35.3312 30.5636 34.4323 31.0507 33.1736 31.5222C32.3056 31.8639 31.7361 32.148 31.4651 32.3747C31.2016 32.6033 31.0092 32.9441 30.8879 33.3968L30.7059 34.076L27.7063 33.2722ZM26.3068 37.0464C26.4766 36.4125 26.7748 35.9789 27.2013 35.7454C27.6279 35.5119 28.1656 35.4821 28.8146 35.6559C29.4409 35.8238 29.8794 36.1192 30.13 36.5422C30.3882 36.9673 30.4344 37.4892 30.2686 38.108C30.1088 38.7042 29.8089 39.1293 29.3687 39.3834C28.9306 39.63 28.4022 39.6704 27.7834 39.5046C27.1495 39.3347 26.7035 39.0373 26.4453 38.6122C26.1892 38.1796 26.143 37.6577 26.3068 37.0464Z" fill="#F08800"/>
          </svg>
        </span>
        <p>
          By confirming the action you will be revoking this group access to MuleEX. Do you wish to proceed?
        </p>
        <p class="my-2">
          State the reason for deactivation
        </p>
          <textarea placeholder="Enter your reason(s)" class="bg-gray-100 w-full my-2" name="" id="" cols="20" rows="3" v-model="reasonDeactivated.deactivationReason"
          ></textarea>
          <div class="flex items-center justify-between">
            <div class="cursor-pointer" @click="closeModal">
              <p>Cancel</p>
            </div>
            <primary-button buttonText="Deactivate" :disabled="disableButton" @click="deactivateUser" :loading="deactivatingUser"/>
          </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      deactivatingUser: false,
      reasonDeactivated: {
        deactivationReason: "",
        isActive: false,
        id: this.user.id,
      },
    };
  },

  computed: {
     payload() {
      return {
        deactivationReason: this.reasonDeactivated.deactivationReason,
      };
    },
    disableButton() {
      if(this.reasonDeactivated.deactivationReason.length){
        return false;
      }
      return true;
    }
  },
  methods: {
    async deactivateUser() {
      this.deactivatingUser = true;
      try {
        let response = await this.$_deactivateUser(
          this.user.id,
          // this.reasonDeactivated
          this.payload
        );
        this.reasonDeactivated.deactivationReason = ''
        console.log(response);
        this.deactivatingUser = false;
        this.onUserDeactivated();
      } catch (error) {
        this.handleError(error);
        console.log(error);
        this.deactivatingUser = false;
      }
    },
    onUserDeactivated() {
      this.closeModal();
      this.generateToast("User successfully deactivated", "success");
      this.$emit("user-deactivated");
    },
    closeModal() {
    this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
